const ls = {
  set: function(key, value, ttlMs = 3600000) {
    const data = {value: value, expires_at: new Date().getTime() + ttlMs / 1};
    localStorage.setItem(key.toString(), JSON.stringify(data));
  },
  get: function(variable) {
    const data = JSON.parse(localStorage.getItem(variable.toString()));
    if (data !== null) {
      if (data.expires_at !== null && data.expires_at !== -1 && data.expires_at < new Date().getTime()) {
        localStorage.removeItem(variable.toString());
      } else {
        return data.value;
      }
    }
    return null;
  },
  delete: function(variable) {
    localStorage.removeItem(variable.toString());
  },
};

module.exports = ls;
